module.exports = __webpack_public_path__ + "img/2023-03-18-planning.7ef9649.jpg";